// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CitySectionSwiperSkeleton-categorySkeletonList-RRCMx {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 30px;
    margin-top: 48px;
}

.CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD {
    padding: 8px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 18px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.CitySectionSwiperSkeleton-categorySkeletonImg-z_Q_P {
    max-width: 138px;
    height: 142px;
    border-top-right-radius: 18px;
    border-bottom-left-radius: 18px;
}

.CitySectionSwiperSkeleton-categorySkeletonContent-salVX {
    max-width: 92px;
    height: 28px;
    border-radius: var(--radius-5);
}

@media (max-width: 1299px) and (min-width: 1024px) {
    .CitySectionSwiperSkeleton-categorySkeletonList-RRCMx {
        grid-template-columns: repeat(5, 1fr);
        gap: 20px;
    }

    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(6),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(7) {
        display: none;
    }
}

@media (max-width: 1023px) and (min-width: 768px) {
    .CitySectionSwiperSkeleton-categorySkeletonList-RRCMx {
        grid-template-columns: repeat(4, 1fr);
        gap: 10px;
    }

    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(5),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(6),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(7) {
        display: none;
    }
}

@media (max-width: 767px) and (min-width: 640px) {
    .CitySectionSwiperSkeleton-categorySkeletonList-RRCMx {
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
    }

    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(4),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(5),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(6),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(7) {
        display: none;
    }
}

@media (max-width: 767px) {
    .CitySectionSwiperSkeleton-categorySkeletonList-RRCMx {
        margin-top: 30px;
    }
}

@media (max-width: 639px) and (min-width: 360px) {
    .CitySectionSwiperSkeleton-categorySkeletonList-RRCMx {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
    }

    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(3),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(4),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(5),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(6),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(7) {
        display: none;
    }
}

@media (max-width: 359px) {
    .CitySectionSwiperSkeleton-categorySkeletonList-RRCMx {
        grid-template-columns: 100%;
        gap: 10px;
    }

    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(2),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(3),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(4),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(5),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(6),
    .CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD:nth-child(7) {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/Home/CitySectionSkeleton/CitySectionSwiperSkeleton/CitySectionSwiperSkeleton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,SAAS;IACT,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,+BAA+B;AACnC;;AAGA;IACI,eAAe;IACf,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;;;QAGI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;;;;QAII,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;;;;;QAKI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,SAAS;IACb;;IAEA;;;;;;QAMI,aAAa;IACjB;AACJ","sourcesContent":[".categorySkeletonList {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 30px;\n    margin-top: 48px;\n}\n\n.categorySkeletonListItem {\n    padding: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    align-items: center;\n}\n\n.categorySkeletonImg {\n    max-width: 138px;\n    height: 142px;\n    border-top-right-radius: 18px;\n    border-bottom-left-radius: 18px;\n}\n\n\n.categorySkeletonContent {\n    max-width: 92px;\n    height: 28px;\n    border-radius: var(--radius-5);\n}\n\n@media (max-width: 1299px) and (min-width: 1024px) {\n    .categorySkeletonList {\n        grid-template-columns: repeat(5, 1fr);\n        gap: 20px;\n    }\n\n    .categorySkeletonListItem:nth-child(6),\n    .categorySkeletonListItem:nth-child(7) {\n        display: none;\n    }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n    .categorySkeletonList {\n        grid-template-columns: repeat(4, 1fr);\n        gap: 10px;\n    }\n\n    .categorySkeletonListItem:nth-child(5),\n    .categorySkeletonListItem:nth-child(6),\n    .categorySkeletonListItem:nth-child(7) {\n        display: none;\n    }\n}\n\n@media (max-width: 767px) and (min-width: 640px) {\n    .categorySkeletonList {\n        grid-template-columns: repeat(3, 1fr);\n        gap: 20px;\n    }\n\n    .categorySkeletonListItem:nth-child(4),\n    .categorySkeletonListItem:nth-child(5),\n    .categorySkeletonListItem:nth-child(6),\n    .categorySkeletonListItem:nth-child(7) {\n        display: none;\n    }\n}\n\n@media (max-width: 767px) {\n    .categorySkeletonList {\n        margin-top: 30px;\n    }\n}\n\n@media (max-width: 639px) and (min-width: 360px) {\n    .categorySkeletonList {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 10px;\n    }\n\n    .categorySkeletonListItem:nth-child(3),\n    .categorySkeletonListItem:nth-child(4),\n    .categorySkeletonListItem:nth-child(5),\n    .categorySkeletonListItem:nth-child(6),\n    .categorySkeletonListItem:nth-child(7) {\n        display: none;\n    }\n}\n\n@media (max-width: 359px) {\n    .categorySkeletonList {\n        grid-template-columns: 100%;\n        gap: 10px;\n    }\n\n    .categorySkeletonListItem:nth-child(2),\n    .categorySkeletonListItem:nth-child(3),\n    .categorySkeletonListItem:nth-child(4),\n    .categorySkeletonListItem:nth-child(5),\n    .categorySkeletonListItem:nth-child(6),\n    .categorySkeletonListItem:nth-child(7) {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categorySkeletonList": `CitySectionSwiperSkeleton-categorySkeletonList-RRCMx`,
	"categorySkeletonListItem": `CitySectionSwiperSkeleton-categorySkeletonListItem-tlfMD`,
	"categorySkeletonImg": `CitySectionSwiperSkeleton-categorySkeletonImg-z_Q_P`,
	"categorySkeletonContent": `CitySectionSwiperSkeleton-categorySkeletonContent-salVX`
};
module.exports = ___CSS_LOADER_EXPORT___;
